(function () {
  function bindAddToCart(root) {
    root.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      if (form.dataset.redirectBound === '1') return;
      form.dataset.redirectBound = '1';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var fd = new FormData(form);
        if (!fd.get('quantity')) fd.append('quantity', 1);
        if (!fd.get('id') && form.querySelector('[name="id"]')) {
          fd.append('id', form.querySelector('[name="id"]').value);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            window.location.assign('/cart'); // zet '/checkout' als je direct wil afrekenen
          })
          .catch(function () {
            window.location.assign('/cart');
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { bindAddToCart(document); });
  document.addEventListener('shopify:section:load', function (e) { bindAddToCart(e.target); });
})();